<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 11V9H11.5V11H9.5Z" fill="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 15V13H11.5V15H9.5Z" fill="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 11V9H15.5V11H13.5Z" fill="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 15V13H15.5V15H13.5Z" fill="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 11V9H11.5V11H9.5Z" stroke="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 15V13H11.5V15H9.5Z" stroke="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 11V9H15.5V11H13.5Z" stroke="#000"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 15V13H15.5V15H13.5Z" stroke="#000"/>
  <path d="M3.5 10V3H10.5M15 3H21.5V10M3.5 14.5V21H9.5M15.5 21H21.5V14.5" stroke="#000"/>
</svg>
